import { render, staticRenderFns } from "./PetaBahaya.vue?vue&type=template&id=c071c226&scoped=true"
import script from "./PetaBahaya.vue?vue&type=script&lang=js"
export * from "./PetaBahaya.vue?vue&type=script&lang=js"
import style0 from "./PetaBahaya.vue?vue&type=style&index=0&id=c071c226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c071c226",
  null
  
)

export default component.exports